import { Component }              from '@angular/core';
import { MatDialogRef }            from '@angular/material';
import { Globals }                from './../common/globals';

@Component({
  selector: 'sa-receipt-dialog',
  template: require('./receipt-dialog.component.html'),
  styles: [require('./receipt-dialog.component.scss')]
})
export class ReceiptDialogComponent {
  public model: any;
  constructor(
    public globals: Globals,
    public dialogRef: MatDialogRef<ReceiptDialogComponent>
  ) {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/receipt-dialog/receipt-dialog.component.ts